<template>
  <teleport to="body">
    <div v-if="show" @click="tryClose" class="backdrop"></div>
    
    <transition name="dialog">      
      <dialog open v-if="show" class="dialog-box edit" :style="styleWidth">
        <header>
          <div v-if="showCloseIcon" class="icons">
                <button class="spec-btn" @click="tryClose" title="Close">
                  <app-icon icon="hugeicons:cancel-circle" width="18" />
                </button>
          </div>
          <slot name="header">
            <h2>{{ title }}</h2>
          </slot>
        </header>
        <section>
          <slot name="content">
          </slot>
        </section>
        <menu v-if="!fixed">
          <slot name="actions">
          </slot>
        </menu>
      </dialog>
    </transition>
  </teleport>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    showCloseIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: false,
    },
    fixed: {
      type: Boolean,
      required: false,
      default: false,
    },
    windowWidth: {
      type: Number,
      required: false,
      default: 576,
    },

  },
  computed: {
      styleWidth() {

        let ret = {};

        if (this.windowWidth == 0) {
          ret = {    
            '--style-left': '0',
            '--style-width': '100%'
          };            
        }
        else {
          ret = {    
            '--style-left': 'calc(50% - '+this.windowWidth/2+'px)',
            '--style-width': this.windowWidth+'px'
          };
        }

        return ret;
      }
  },


  emits: ["close"],
  methods: {
    tryClose() {
      if (this.fixed) {
        return;
      }
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);  
  z-index: 10;
}

dialog {
  position: fixed;
  top: 9vh;
  left: 10%;
  width: 80%;
  z-index: 100;
  border-radius: 12px;
  border: 1px solid var(--border, #e5e7eb);
  box-shadow: 0 1px 3px rgba(0,0,0,0.05), 0 10px 25px rgba(0,0,0,0.1);
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-color: var(--bg-card, #ffffff);
  font-family: 'Inter', sans-serif;
}

header {
  background-color: var(--bg-card, #ffffff);
  width: 100%;
  padding: 24px 32px;
  border-bottom: 1px solid var(--border, #e5e7eb);
  position: relative;
}

header .icons {
  position: absolute;
  top: 10px;
  right: 12px;
}

header .icons i {
  font-size: 20px;
  color: var(--text-muted, #6b7280);
}

header .i-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  margin-left: 4px;
  border-radius: 6px;
  transition: 0.2s;
}

header .i-btn:hover {
  background: var(--bg-page, #f0f4f9);
}

header h2 {
  margin: 0;
  color: var(--text-main, #111827);
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: normal;
  text-transform: none;
}

section {
  padding: 20px 32px 48px;
  color: var(--text-main, #111827);
}

menu {
  padding: 24px 32px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin: 0;
  border-top: 1px solid var(--border, #e5e7eb);
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.dialog-enter-active {
  transition: all 0.3s ease-out;
}

.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: scale(1);
}

@media (min-width: 768px) {
  dialog {
    left: calc(50% - 288px);
    width: 576px;
  }

  dialog {
    left: var(--style-left);
    width: var(--style-width);
  }
}

.mobile dialog.dialog-box {
  left: var(--style-left);
  width: var(--style-width);
  top: 0;
  transform: translate(0, 0);
  position: fixed;
  height: 100vh;
  margin: 0 auto;
}

</style>
